// dayjs com o plugin de UTC já ativo, para quem usa dayjs.utc(...) (datas do
// servidor). Importar daqui em vez de 'dayjs' não depende da ordem de carregamento.
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export default dayjs
